export default "__VITE_ASSET__4b0ff7f9__"